import React from 'react';
import { cn } from '../utils/cn';

interface TextBlockProps {
    content: string;
    className?: string;
}

/**
 * Render text content with proper formatting
 * - Preserves whitespace and line breaks
 * - Uses semantic typography
 */
export function TextBlock({ content, className }: TextBlockProps) {
    if (!content) return null;

    return (
        <div className={cn('prose prose-sm max-w-none dark:prose-invert', className)}>
            <p className="whitespace-pre-wrap leading-relaxed text-gray-900 dark:text-gray-100">
                {content}
            </p>
        </div>
    );
}
